import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { DefaultService } from '../types/admin';
import type { ServiceRequest } from '../types/provider';

// Default Service API methods (for SUPER_ADMIN)
export const defaultServiceApi = {
	/**
	 * Get all default services
	 */
	getAll: async (): Promise<DefaultService[]> => {
		return apiClient.get<DefaultService[]>(API_ENDPOINTS.DEFAULT_SERVICE);
	},

	/**
	 * Create a new default service
	 */
	create: async (data: ServiceRequest): Promise<DefaultService> => {
		return apiClient.post<DefaultService>(API_ENDPOINTS.DEFAULT_SERVICE, data);
	},

	/**
	 * Update an existing default service
	 */
	update: async (serviceId: number, data: ServiceRequest): Promise<DefaultService> => {
		return apiClient.put<DefaultService>(`${API_ENDPOINTS.DEFAULT_SERVICE}/${serviceId}`, data);
	},

	/**
	 * Delete a default service by ID
	 */
	delete: async (serviceId: number): Promise<void> => {
		await apiClient.delete(`${API_ENDPOINTS.DEFAULT_SERVICE}/${serviceId}`);
	},
};

export default defaultServiceApi;
